<div class="mm-pptx-viewer" #root [class.mm-pptx-viewer--fullscreen]="isFullscreen">
  <div class="mm-pptx-stage" #stage>
    <div class="mm-pptx-canvas-wrap" [style.transform]="'scale(' + zoom + ')'">
      <canvas #slideCanvas class="mm-pptx-canvas" aria-label="Slide da apresentação"></canvas>
    </div>
    <div class="mm-pptx-overlay" *ngIf="loading">Carregando apresentação…</div>
    <div class="mm-pptx-overlay mm-pptx-overlay--error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>

  <footer class="mm-pptx-footer">
    <div class="mm-pptx-nav">
      <button type="button" class="mm-pptx-btn" [disabled]="!canGoPrev || loading" (click)="prevSlide()">
        ‹ Anterior
      </button>
      <span class="mm-pptx-counter" *ngIf="slideCount > 0">
        Slide {{ currentSlide + 1 }} / {{ slideCount }}
      </span>
      <button type="button" class="mm-pptx-btn mm-pptx-btn--primary" [disabled]="!canGoNext || loading" (click)="nextSlide()">
        Próximo ›
      </button>
    </div>

    <div class="mm-pptx-tools">
      <button type="button" class="mm-pptx-btn" [disabled]="loading || zoom <= 0.75" (click)="zoomOut()" aria-label="Diminuir zoom">
        −
      </button>
      <button type="button" class="mm-pptx-btn" [disabled]="loading || zoom === 1" (click)="resetZoom()" aria-label="Zoom padrão">
        {{ (zoom * 100) | number:'1.0-0' }}%
      </button>
      <button type="button" class="mm-pptx-btn" [disabled]="loading || zoom >= 2" (click)="zoomIn()" aria-label="Aumentar zoom">
        +
      </button>
      <button type="button" class="mm-pptx-btn" [disabled]="loading" (click)="toggleFullscreen()" [attr.aria-label]="isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'">
        {{ isFullscreen ? 'Sair' : 'Tela cheia' }}
      </button>
      <button
        type="button"
        class="mm-pptx-btn mm-pptx-download"
        *ngIf="canDownload && data"
        (click)="download()">
        Baixar
      </button>
    </div>
  </footer>
</div>
